var _circle, _circle2, _circle3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromptIconW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#FBF8E9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48.001,
    r: 37.7705,
    fill: "#F0BB01",
    fillOpacity: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.7377,
    cy: 47.7372,
    r: 28.8525,
    fill: "#F0BB01"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2731_6004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0001 36.416C54.6737 36.416 60.0834 41.8257 60.0834 48.4993C60.0834 55.173 54.6737 60.5827 48.0001 60.5827C41.3265 60.5827 35.9167 55.173 35.9167 48.4993C35.9167 41.8257 41.3265 36.416 48.0001 36.416ZM48.0001 38.8327C45.4363 38.8327 42.9776 39.8511 41.1647 41.664C39.3519 43.4768 38.3334 45.9356 38.3334 48.4993C38.3334 51.0631 39.3519 53.5219 41.1647 55.3347C42.9776 57.1476 45.4363 58.166 48.0001 58.166C50.5638 58.166 53.0226 57.1476 54.8354 55.3347C56.6483 53.5219 57.6667 51.0631 57.6667 48.4993C57.6667 45.9356 56.6483 43.4768 54.8354 41.664C53.0226 39.8511 50.5638 38.8327 48.0001 38.8327ZM48.0001 52.1243C48.3206 52.1243 48.6279 52.2517 48.8545 52.4783C49.0811 52.7049 49.2084 53.0122 49.2084 53.3327C49.2084 53.6532 49.0811 53.9605 48.8545 54.1871C48.6279 54.4137 48.3206 54.541 48.0001 54.541C47.6796 54.541 47.3723 54.4137 47.1457 54.1871C46.9191 53.9605 46.7917 53.6532 46.7917 53.3327C46.7917 53.0122 46.9191 52.7049 47.1457 52.4783C47.3723 52.2517 47.6796 52.1243 48.0001 52.1243ZM48.0001 41.2493C48.3206 41.2493 48.6279 41.3767 48.8545 41.6033C49.0811 41.8299 49.2084 42.1372 49.2084 42.4577V49.7077C49.2084 50.0282 49.0811 50.3355 48.8545 50.5621C48.6279 50.7887 48.3206 50.916 48.0001 50.916C47.6796 50.916 47.3723 50.7887 47.1457 50.5621C46.9191 50.3355 46.7917 50.0282 46.7917 49.7077V42.4577C46.7917 42.1372 46.9191 41.8299 47.1457 41.6033C47.3723 41.3767 47.6796 41.2493 48.0001 41.2493Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2731_6004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(33.5 34)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptIconW);
export default __webpack_public_path__ + "static/media/promptIconW.d4d7f7d0f88e8cc4b90ade6d29550fa0.svg";
export { ForwardRef as ReactComponent };